import { css, Theme } from '@emotion/react'
import {
  Typography,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from '@mui/material'

const CompanySummary = () => {
  const rows = [
    { head: '事業者名', description: 'オフィスeduad' },
    // {
    //   head: '所在地',
    //   description: '〒252-0206 神奈川県相模原市中央区淵野辺2丁目5番62号',
    // },
    // { head: '代表', description: '大宮 綾' },
    // { head: 'お問い合わせ先', description: 'info@edu-ad.com' },
  ]

  return (
    <>
      <div>
        <TableContainer component='div' css={styles.tableContainer}>
          <Typography
            color='primary'
            component='h1'
            variant='h1'
            css={styles.header}>
            INFORMATION
          </Typography>
          <Typography color='primary' variant='h2' css={styles.subtitle}>
            事業者情報
          </Typography>
          <Table css={styles.table} aria-label='simple table'>
            <TableBody>
              {rows.map(row => (
                <TableRow key={row.head} css={styles.row}>
                  <TableCell component='th' scope='row' css={styles.th}>
                    {row.head}
                  </TableCell>
                  <TableCell component='td' scope='row' css={styles.td}>
                    {row.description}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow css={styles.row}>
                <TableCell component='th' scope='row' css={styles.th}>
                  事業内容
                </TableCell>
                <TableCell component='td' scope='row' css={styles.td}>
                  <ul css={styles.list}>
                    <li>戦略設計：マーケティング</li>
                    <li>広告運用代行：ウェブ運用型広告</li>
                    <li>
                      クリエイティブ制作：ウェブサイト制作／ウェブ広告クリエイティブ／映像制作
                      など
                    </li>
                  </ul>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  )
}

const styles = {
  tableContainer: css`
    width: 80vw;
    max-width: 1100px;
    margin: 150px auto 30px;
    margin-bottom: 150px;
    @media (max-width: 768px) {
      width: 90vw;
    }
  `,
  header: css`
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 4rem;
    margin-bottom: 1rem;
    @media (max-width: 768px) {
      font-size: 3rem;
    }
  `,
  subtitle: css`
    line-height: 3rem;
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 3rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }
  `,
  table: css`
    * {
      font-family: 'Noto sans JP', sans-serif;
    }
    margin-bottom: 50px;
    margin-left: 200px;
    @media (max-width: 768px) {
      margin-left: 0;
    }
  `,
  row: css`
    height: 100px;
    &:first-of-type {
      border-top: 0.6px solid rgba(128, 128, 128, 0.3);
    }
    @media (max-width: 768px) {
      height: auto;
      display: block;
      padding-left: 10px;
      &:first-of-type {
        border-top: none;
      }
    }
  `,
  th: (theme: Theme) => css`
    width: 20%;
    font-size: 1rem;
    @media (max-width: 768px) {
      width: 85vw;
      display: block;
      font-size: 0.9rem;
      font-weight: 900;
      padding: 20px 0 20px 10px;
      border-bottom: 0.2px solid ${theme.palette.primary.main};
    }
  `,
  td: css`
    @media (max-width: 768px) {
      border-bottom: none;
      padding-left: 20px;
    }
  `,
  list: css`
    list-style: none;
    padding-inline-start: 0;
  `,
}

export default CompanySummary
